import type { ChannelType } from '../enums/ChannelTypeEnum'
import type { ChannelStatus } from '../enums/ChannelStatusEnum'
import type { ChannelTranslationEntity } from './ChannelTranslationEntity'
import type { ChannelItemType } from '../enums/ChannelItemTypeEnum'
import type { AppServiceType } from '../enums/AppServiceTypeEnum'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class ChannelEntity {
  id?: number
  imageUrl?: string | null
  translations?: Array<ChannelTranslationEntity> | null
  type?: ChannelType | null
  status?: ChannelStatus | null
  coverImageUrl?: string | null
  appServiceType?: AppServiceType | null
  itemType?: ChannelItemType | null
  isVirtual?: boolean | null
  zohoBooksChannelName?: string | null
  zohoBooksChannelOrderType?: string | null
  color?: string | null
  regions?: Array<RegionMiniEntity> | null
  isBranchTagFilterMultiple?: boolean | null
}
